(() => {
  const initialize = (root) => {
    if (!root || root.dataset.poaigReady === 'true') return;
    root.dataset.poaigReady = 'true';

    const track = root.querySelector('[data-poaig-track]');
    const slides = [...root.querySelectorAll('[data-poaig-slide]')];
    const dots = [...root.querySelectorAll('[data-poaig-dot]')];
    const previous = root.querySelector('[data-poaig-prev]');
    const next = root.querySelector('[data-poaig-next]');
    if (!track || slides.length === 0) return;

    let current = 0;
    const show = (requested) => {
      current = (requested + slides.length) % slides.length;
      track.style.transform = `translate3d(${-100 * current}%,0,0)`;
      slides.forEach((slide, index) => {
        slide.classList.toggle('is-active', index === current);
        slide.setAttribute('aria-hidden', index === current ? 'false' : 'true');
      });
      dots.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === current);
        if (index === current) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    };

    previous?.addEventListener('click', () => show(current - 1));
    next?.addEventListener('click', () => show(current + 1));
    dots.forEach((dot) => dot.addEventListener('click', () => show(Number(dot.dataset.poaigDot))));
    root.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') show(current - 1);
      if (event.key === 'ArrowRight') show(current + 1);
    });

    let touchStart = null;
    root.addEventListener('touchstart', (event) => {
      const touch = event.touches[0];
      touchStart = touch ? { x: touch.clientX, y: touch.clientY } : null;
    }, { passive: true });
    root.addEventListener('touchend', (event) => {
      if (touchStart === null) return;
      const touch = event.changedTouches[0];
      const distanceX = (touch?.clientX ?? touchStart.x) - touchStart.x;
      const distanceY = (touch?.clientY ?? touchStart.y) - touchStart.y;
      if (Math.abs(distanceX) > Math.abs(distanceY) && Math.abs(distanceX) > 55) {
        show(current + (distanceX < 0 ? 1 : -1));
      }
      touchStart = null;
    }, { passive: true });

    show(0);
  };

  const initializeAll = () => document.querySelectorAll('[data-poaig-carousel]').forEach(initialize);
  const initializeProducts = () => document.querySelectorAll('[data-poaig-product]').forEach((root) => {
    if (root.dataset.poaigProductReady === 'true') return;
    root.dataset.poaigProductReady = 'true';
    const radios = [...root.querySelectorAll('input[type="radio"][name="id"]')];
    const price = document.querySelector('[data-poaig-price]');
    const engraving = root.querySelector('[data-poaig-engraving]');
    const addButton = root.querySelector('button[name="add"]');
    const addLabel = root.querySelector('[data-poaig-add-label]');
    const isSpanish = document.documentElement.lang.toLowerCase().startsWith('es');

    const update = () => {
      const selected = radios.find((radio) => radio.checked);
      if (!selected) return;
      radios.forEach((radio) => radio.closest('label')?.classList.toggle('is-selected', radio === selected));
      if (price && selected.dataset.price) price.textContent = selected.dataset.price;
      if (engraving) {
        const showEngraving = selected.dataset.engraved === 'true';
        engraving.hidden = !showEngraving;
        const engravingInput = engraving.querySelector('input');
        if (engravingInput) engravingInput.disabled = !showEngraving;
      }
      const available = selected.dataset.available !== 'false';
      if (addButton) addButton.disabled = !available;
      if (addLabel) addLabel.textContent = available ? (isSpanish ? 'AÑADIR' : 'ADD') : (isSpanish ? 'AGOTADO' : 'SOLD OUT');
    };
    radios.forEach((radio) => radio.addEventListener('change', update));
    update();
  });

  const initializeReviews = () => {
    const root = document.querySelector('#klaviyo-product-reviews-wrapper');
    if (!root) return;

    const items = [...root.querySelectorAll('.kl_reviews__review_item')];
    if (items.length === 0) return;

    const isSpanish = document.documentElement.lang.toLowerCase().startsWith('es');
    const average = root.querySelector('.kl_reviews__summary__average_value');
    if (average && average.dataset.poaigFormatted !== 'true') {
      const value = Number.parseFloat(average.textContent.replace(',', '.'));
      if (Number.isFinite(value)) average.textContent = isSpanish ? value.toFixed(2).replace('.', ',') : value.toFixed(2);
      average.dataset.poaigFormatted = 'true';
    }

    const source = root.querySelector('.kl_reviews__summary__stars__count');
    if (source) {
      const sourceText = isSpanish
        ? `${items.length} ${items.length === 1 ? 'RESEÑA · RECOGIDA' : 'RESEÑAS · RECOGIDAS'} A TRAVÉS DE KLAVIYO`
        : `${items.length} ${items.length === 1 ? 'REVIEW' : 'REVIEWS'} · COLLECTED THROUGH KLAVIYO`;
      if (source.textContent !== sourceText) source.textContent = sourceText;
    }

    items.forEach((item, index) => item.classList.toggle('poaig-review-extra', index > 2));
    const status = root.querySelector('#reviewslist .kl_reviews__list_container > div[role="status"]');
    if (!status || items.length <= 3) return;

    let toggle = root.querySelector('.poaig-reviews-more');
    if (!toggle) {
      toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'poaig-reviews-more';
      toggle.innerHTML = '<span></span><span aria-hidden="true">+</span>';
      status.after(toggle);

      const note = document.createElement('p');
      note.className = 'poaig-reviews-original-note';
      note.textContent = isSpanish ? 'Las reseñas se muestran en su idioma original.' : 'Reviews are shown in their original language.';
      toggle.after(note);

      toggle.addEventListener('click', () => {
        const expanded = root.classList.toggle('is-expanded');
        toggle.setAttribute('aria-expanded', String(expanded));
        toggle.lastElementChild.textContent = expanded ? '−' : '+';
      });
    }

    const remaining = items.length - 3;
    const toggleText = isSpanish ? `VER LAS ${remaining} RESEÑAS RESTANTES` : `VIEW THE REMAINING ${remaining} REVIEWS`;
    if (toggle.firstElementChild.textContent !== toggleText) toggle.firstElementChild.textContent = toggleText;
    toggle.setAttribute('aria-expanded', String(root.classList.contains('is-expanded')));
  };

  const initializeFilms = () => {
    const modal = document.querySelector('[data-poaig-film-modal]');
    if (!modal || modal.dataset.poaigFilmReady === 'true') return;
    modal.dataset.poaigFilmReady = 'true';

    const panel = modal.querySelector('[data-poaig-film-panel]');
    const title = modal.querySelector('[data-poaig-film-title]');
    const iframe = modal.querySelector('[data-poaig-film-youtube]');
    const video = modal.querySelector('[data-poaig-film-video]');
    const closeButton = modal.querySelector('[data-poaig-film-close]');
    let opener = null;
    let previousOverflow = '';

    const close = () => {
      if (modal.hidden) return;
      modal.hidden = true;
      if (iframe) {
        iframe.src = '';
        iframe.hidden = true;
      }
      if (video) {
        video.pause();
        video.removeAttribute('src');
        video.load();
        video.hidden = true;
      }
      document.body.style.overflow = previousOverflow;
      opener?.focus();
    };

    document.querySelectorAll('[data-poaig-film-open]').forEach((button) => {
      button.addEventListener('click', () => {
        opener = button;
        previousOverflow = document.body.style.overflow;
        if (title) title.textContent = button.dataset.filmTitle || '';
        if (button.dataset.filmKind === 'youtube' && iframe) {
          iframe.title = button.dataset.filmTitle || '';
          iframe.src = button.dataset.filmSrc || '';
          iframe.hidden = false;
        } else if (video) {
          video.src = button.dataset.filmSrc || '';
          if (button.dataset.filmPoster) video.poster = button.dataset.filmPoster;
          else video.removeAttribute('poster');
          video.hidden = false;
          video.load();
          video.play().catch(() => {});
        }
        modal.hidden = false;
        document.body.style.overflow = 'hidden';
        closeButton?.focus();
      });
    });

    closeButton?.addEventListener('click', close);
    modal.addEventListener('click', (event) => {
      if (event.target === modal) close();
    });
    panel?.addEventListener('click', (event) => event.stopPropagation());
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !modal.hidden) close();
    });
  };

  const initializeHeader = () => {
    document.querySelectorAll('.poaig-header:not(.poaig-header--paper)').forEach((header) => {
      if (header.dataset.poaigHeaderReady === 'true') return;
      header.dataset.poaigHeaderReady = 'true';
      let frame = null;
      const update = () => {
        frame = null;
        header.classList.toggle('is-scrolled', window.scrollY > 32);
      };
      const requestUpdate = () => {
        if (frame !== null) return;
        frame = requestAnimationFrame(update);
      };
      window.addEventListener('scroll', requestUpdate, { passive: true });
      update();
    });
  };

  const initializeAllFeatures = () => {
    initializeAll();
    initializeProducts();
    initializeReviews();
    initializeFilms();
    initializeHeader();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAllFeatures, { once: true });
  else initializeAllFeatures();
  document.addEventListener('shopify:section:load', initializeAll);
  document.addEventListener('shopify:section:load', initializeProducts);
  document.addEventListener('shopify:section:load', initializeReviews);
  document.addEventListener('shopify:section:load', initializeHeader);

  let reviewFrame = null;
  new MutationObserver(() => {
    if (reviewFrame) cancelAnimationFrame(reviewFrame);
    reviewFrame = requestAnimationFrame(initializeReviews);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
